/* eslint-disable camelcase */

interface Connex {
  annotationTextArea?: string;
  c_ActiveCurrency: string;
  c_ActiveCountry: string;
  c_PromotionId?: string;
  c_PromotionContentReference?: string;
  isIntoChangingCountry: boolean;
  isIntoSettingPhoneNoInShippingStep: boolean;
  c_links: {
    URL_Privacy: string;
    URL_TermsAndConditions: string;
    URL_RevocationRights: string;
    URL_Imprint: string;
    URL_Search: string;
    ContactPhone: string;
  };
}

declare const window: Window & Connex;

export default window;
